// Resolves the initial session before the router renders.
// 1. If the OAuth callback left an access token in the URL fragment, adopt it.
// 2. Otherwise try a silent refresh using the HttpOnly refresh cookie.
// 3. Load the current user (and integrations) into the store.

import { store } from './store.js'
import { api, setAccessToken, tryRefresh } from './api.js'

function readTokenFromHash() {
  if (!window.location.hash) return null
  const params = new URLSearchParams(window.location.hash.slice(1))
  const token = params.get('access_token')
  if (token) {
    // Strip the fragment so the token does not linger in the address bar.
    history.replaceState(null, '', window.location.pathname + window.location.search)
  }
  return token
}

export async function bootstrapAuth() {
  try {
    const hashToken = readTokenFromHash()
    if (hashToken) {
      setAccessToken(hashToken)
    } else {
      await tryRefresh()
    }

    const user = await api.get('/users/me').catch(() => null)
    if (user) {
      const integrations = await api.get('/integrations').catch(() => [])
      store.set({ user, integrations })
    }
  } finally {
    store.set({ authReady: true })
  }
}
